import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer";
import Product from "./Components/Product";
import Productinfo from "./Components/Productinfo";
import Distributor from "./Components/Distributor";
import ContactUs from "./Components/ContactUs";
import AboutUs from "./Components/AboutUs";
import { ToastContainer, Zoom } from "react-toastify";
import Instagram from "./Components/Instagram";
import WhatsAppButton from "./Components/CustomTool/WhatsAppButton";
// import { WhatsAppWidget } from "react-whatsapp-widget";
// import "react-whatsapp-widget/dist/index.css";
function App() {
  return (
    <HashRouter>
      <div className="MyApp">
        <Navbar />
        <WhatsAppButton />
        {/* <WhatsAppWidget
          phoneNumber="919925534220"
          message="Hello! How can I help you?"
          companyName="MR Products"
          sendButton="Send"
        /> */}

        <ToastContainer
          position="top-center"
          autoClose={4000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Zoom}
        />

        <Routes>
          <Route path="/" exact element={<Home />}></Route>
          <Route path="Product" exact element={<Product />}></Route>
          <Route path="AboutUs" exact element={<AboutUs />}></Route>
          <Route path="Productinfo" exact element={<Productinfo />}></Route>
          <Route path="Distributor" exact element={<Distributor />}></Route>
          <Route path="ContactUs" exact element={<ContactUs />}></Route>
          <Route path="Instagram" exact element={<Instagram />}></Route>
        </Routes>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;
